"use strict";
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
const messageUtils = __importStar(require("./messageUtils"));
const BaseMessage_1 = require("./BaseMessage");
const MessageElement_1 = require("./internal/MessageElement");
const utils_1 = require("../../internal/utils");
const GREY_L2 = "#e0e0e0";
class InfoMessage extends BaseMessage_1.BaseMessage {
    createMessageElementInternal() {
        return new MessageElement_1.MessageElement();
    }
    drawCellMessageInternal(_message, context, style, helper, grid, _info) {
        const { bgColor } = style;
        const { select } = context.getSelection();
        if (!utils_1.cellInRange(grid.getCellRange(context.col, context.row), select.col, select.row) ||
            !grid.hasFocusGrid()) {
            helper.drawBorderWithClip(context, (_ctx) => {
                messageUtils.drawExclamationMarkBox(context, {
                    bgColor: GREY_L2,
                    color: bgColor,
                }, helper);
            });
        }
    }
}
exports.InfoMessage = InfoMessage;
